import * as React from 'react';
import * as styles from './SyncPanel.css';
import { IADropDown } from './../../../dropDown/DropDown';
import { IAButton } from '../../../button/Button';
import { IAIcon } from '../../../icon/Icon';
import { IACheckbox } from './../../../checkbox/Checkbox'
import { TargetingService } from './../../../../services/TargetingService';
import { ITargetTerm } from './../../../../interfaces/ITargetTerm';
import { LocalizationService } from './../../../../services/LocalizationService';
import { inject, observer } from 'mobx-react';
import { TargetingAdminStore } from '../../stores/TargetingAdminStore';
import { IAPanel } from '../../../panels/Panel';

export interface ISyncPanelProps {
  targetingStore?: TargetingAdminStore;

  environment: "Development" | "Test" | "Production";
  tenant: string;
  token: string;
  open: boolean;
  defautTerms: ITargetTerm[];
  highlightColor: string;
  close: (updated: boolean) => void;
}

export interface ISyncPanelState {
  value: string;
  mustSync: boolean;
  groupsAdded: any[]
  termGroupOptions: any;
  termGroupList: any[];
  defautTerms: ITargetTerm[];
  selectedTermGroup: string;
  isLoading: boolean;
  termSetsSelected: { id: string, name: string }[];
}

export interface IGroupAdded {
  isExpanded: boolean;
  title: string;
  id: string;
  terms: ITermSetAdded[];
}

export interface ITermSetAdded {
  termId: string;
  termName: string;
  isSelected: boolean;
}

export interface IComboBoxOption {
  key: string;
  text: string;
  displayName?: string;
  selected?: boolean;
  disabled?: boolean;
}

@inject('targetingStore')
@observer
export class SyncPanel extends React.Component<ISyncPanelProps, ISyncPanelState> {
  constructor(props: ISyncPanelProps, state: ISyncPanelState) {
    super(props, state);

    this.state = {
      value: undefined,
      mustSync: false,
      groupsAdded: [],
      termGroupOptions: [],
      termGroupList: [],
      defautTerms: props.defautTerms,
      selectedTermGroup: undefined,
      isLoading: false,
      termSetsSelected: []
    };
    if (this.props.targetingStore.language != undefined) {
      this.props.targetingStore.setLanguage(this.props.targetingStore.language);
    }
  }

  public componentWillReceiveProps(nextProps) {
    if ((this.state.defautTerms != nextProps.defautTerms) || (this.state.termGroupOptions && this.state.termGroupOptions.length === 0)) {
      this.setState({ defautTerms: nextProps.defautTerms });
      this.loadTerms();
    }
  }

  private loadTerms() {
    TargetingService.getTermsAvailable(this.props.environment, this.props.tenant, this.props.token).then(termAvailable => {

      let _groupsAdded: IGroupAdded[] = [];
      if (this.state.defautTerms.length) {
        this.state.defautTerms.forEach(term => {
          let _groupAdded = _groupsAdded.filter(group => group.title === term.iaTargetingTermsGroup)[0];
          if (_groupAdded === undefined) {
            _groupAdded = {
              id: term.iaTargetingTermsGroupId,
              isExpanded: true,
              terms: [],
              title: term.iaTargetingTermsGroup
            };
            _groupsAdded.push(_groupAdded);
          }
          let _termAdded: ITermSetAdded = {
            isSelected: true,
            termId: term.iaTargetingTermsID,
            termName: term.title
          };

          _groupAdded.terms.push(_termAdded);
        });
      }

      var _groupsOptions: any[] = [];

      _groupsOptions.push({ key: " ", value: " ", selected: true });

      termAvailable.forEach(item => {
        let _groupAdded = _groupsAdded.filter(group => group.title === item.name)[0];
        if (_groupAdded === undefined) {
          _groupsOptions.push({ value: item.name, key: item.id });
        }
        else {
          item.termSets.forEach(termSet => {
            let _termSetAdded = _groupAdded.terms.filter(termSetFromGroup => termSetFromGroup.termName === termSet.name)[0];
            if (_termSetAdded === undefined) {
              //_groupsOptions.push({ text: item.name, key: item.id });

              _groupAdded.terms.push({ isSelected: false, termName: termSet.name, termId: termSet.id });

              // const index = _groupsOptions.indexOf(selectedGroup);
              // if (index > -1) {
              //     _groupsAdded.splice(index, 1);
              // }
            }

            //termsAdded.push({ isSelected: false, termName: x.name, termId: x.id });
          });
        }
      });

      _groupsAdded = _groupsAdded.sort((x, y) => {
        if (x.title > y.title)
          return 1;

        if (x.title < y.title)
          return -1;

        return 0;
      });

      _groupsAdded.forEach(item => {
        item.terms = item.terms.sort((x, y) => {
          if (x.termName > y.termName)
            return 1;

          if (x.termName < y.termName)
            return -1;

          return 0;
        });
      });

      _groupsOptions = _groupsOptions.sort((x, y) => {
        if (x.displayName > y.displayName)
          return 1;

        if (x.displayName < y.displayName)
          return -1;

        return 0;
      });

      if (!_groupsAdded[0] === undefined)
        this.setState({ mustSync: true });

      this.setState({ termGroupOptions: _groupsOptions, termGroupList: termAvailable, groupsAdded: _groupsAdded });
    });
  }

  render() {
    let panel = (
      <div className={styles.IA_viewPanelContentWrapper}>
        <div style={{ marginTop: 20, marginBottom: 20, fontWeight: 700 }}>
          {new LocalizationService().strings.TargetingAdmin_SynchronizeTitle}
        </div>

        <div style={{ marginTop: 20, marginBottom: 40 }}>
          {new LocalizationService().strings.TargetingAdmin_SynchronizeDescription}
        </div>

        <div style={{ marginBottom: 20 }}>
          <IADropDown
            label={new LocalizationService().strings.TargetingAdmin_SynchronizeSelectTermGroup}
            selectedOption={this.state.selectedTermGroup}
            options={this.state.termGroupOptions}
            onChange={this.onTermGroupChanged.bind(this)}
          />
        </div>

        <div>
          {!this.state.mustSync && this.state.groupsAdded.map((object) =>
            <div>
              <span className={styles.filterTitle} style={{ userSelect: 'none', width: '350px' }}>
                <IAIcon
                  url={object.isExpanded ? 'https://intraactivestorage.blob.core.windows.net/cdn/icons/Chevron%20Down/SVG/ic_fluent_chevron_down_48_regular.svg' : 'https://intraactivestorage.blob.core.windows.net/cdn/icons/Chevron%20Up/SVG/ic_fluent_chevron_up_48_regular.svg'}
                  name={object.id ? object.id.toString() : ""}
                  onClick={() => { this._expandCollapse(object.id) }}
                  style={
                    {
                      display: 'block',
                      float: 'left',
                      top: '2px',
                      position: 'relative'
                    }}
                  color={''}
                  size={15}
                />
                {object.title}
                <IAIcon
                  title='Close'
                  name={object.id ? object.id.toString() : ""}
                  onClick={() => { this._removeGroupAdded(object.id) }}
                  style={{
                    display: 'block',
                    float: 'right',
                    top: '-5px',
                    marginRight: '5px',
                    color: '#999'
                  }}
                  color={''}
                  size={15}
                />
              </span>
              {object.isExpanded ? (
                <ul
                  className={styles.list}
                >
                  {object.terms.map(item => {
                    return (<li key={item.termId}>
                      <div>
                        <IACheckbox
                          key={item.termId}
                          label={item.termName}
                          isChecked={item.isSelected}
                          onChange={() => { this._makeChangeHandler(item.termId, object.id) }}
                          highlightColor={this.props.highlightColor}
                        />
                      </div>
                    </li>);
                  })
                  }
                </ul>) : ('')
              }
            </div>
          )}
        </div>
        <div style={{ float: 'left', position: 'absolute', bottom: '0', marginBottom: '20px' }}>
          <IAButton
            style={{ float: 'left' }}
            buttonColor={this.props.highlightColor}
            label={new LocalizationService().strings.TargetingAdmin_SynchronizeSyncTerms}
            icon={"Synchronize"}
            onClick={() => this.syncTermsFromTermStore()}
            showSpinner={this.state.isLoading}
            disbaled={this.state.isLoading}
          />
          <IAButton
            label={new LocalizationService().strings.TargetingAdmin_PropertyPanelCancel}
            buttonColor={"#999999"}
            style={{ marginLeft: "10px", float: 'right' }}
            onClick={() => this.props.close(false)}
            disbaled={this.state.isLoading}
          />
        </div>
      </div>);
    return (
      <div>
        <IAPanel
          showNavigationBar={true}
          itemId={this.props.targetingStore.userGroupToEdit != undefined && this.props.targetingStore.userGroupToEdit.id !== undefined ? this.props.targetingStore.userGroupToEdit.id : undefined}
          open={this.props.open}
          transition={this.props.targetingStore.userGroupToEdit != undefined ? "fade" : "slide"}
          width={550}
          isMobile={false}
          tenant={this.props.targetingStore.tenant}
          token={this.props.targetingStore.token}
          environment={this.props.targetingStore.environment}
          disableSaving={this.props.targetingStore.userGroupToEdit != undefined && this.props.targetingStore.userGroupToEdit.title === undefined
            || this.props.targetingStore.userGroupToEdit != undefined && this.props.targetingStore.userGroupToEdit.title == ""
          }
          // Actions
          close={() => {
            this.props.close(false);
          }}
        >{panel}</IAPanel>
      </div>
    );
  }

  private _expandCollapse = (section: string): void => {
    var _groupsAdded = this.state.groupsAdded;

    var selectedGroup = _groupsAdded.filter(x => x.id === section)[0];
    selectedGroup.isExpanded = !selectedGroup.isExpanded;

    this.setState({ groupsAdded: _groupsAdded });
  }

  private _removeGroupAdded = (groupId: any) => {
    var _groupsAdded = this.state.groupsAdded;
    var selectedGroup: IGroupAdded;
    if (groupId === null) {
      selectedGroup = _groupsAdded[0];
    }
    else {
      selectedGroup = _groupsAdded.filter(x => x.id === groupId)[0];
    }


    if (selectedGroup) {
      const index = _groupsAdded.indexOf(selectedGroup);
      if (index > -1) {
        _groupsAdded.splice(index, 1);
      }

      _groupsAdded = _groupsAdded.sort((x, y) => {
        if (x.title > y.title)
          return 1;

        if (x.title < y.title)
          return -1;

        return 0;
      });

      var _groups: any[] = this.state.termGroupOptions;

      _groups.forEach(element => {
        element.selected = false;
      });

      _groups.push({ key: selectedGroup.id, text: selectedGroup.title, selected: false });

      _groups = _groups.sort((x, y) => {
        if (x.text > y.text)
          return 1;

        if (x.text < y.text)
          return -1;

        return 0;
      });
      this.setState({ termGroupOptions: _groups, groupsAdded: _groupsAdded, selectedTermGroup: " " });
    }
  }

  private _makeChangeHandler = (termId: string, groupId: string) => {
    var _groupsAdded = this.state.groupsAdded;
    var selectedGroup = _groupsAdded.filter(x => x.id.toString() === groupId)[0];

    if (selectedGroup.isExpanded) {
      var selectedTerm = selectedGroup.terms.filter(x => x.termId === termId)[0];
      selectedTerm.isSelected = !selectedTerm.isSelected;
      this.setState({ groupsAdded: _groupsAdded });
    }
  }

  private onTermGroupChanged = (option: any): void => {
    this.setState({ mustSync: false });

    var _groupsAdded = this.state.groupsAdded;
    if (option !== " ") {
      var termGroupSelected = this.state.termGroupList.filter(x => x.id === option)[0];

      var groupAdded: IGroupAdded = {
        id: termGroupSelected.id,
        isExpanded: false,
        title: termGroupSelected.name,
        terms: []
      };

      var termsAdded: ITermSetAdded[] = [];

      termGroupSelected.termSets.forEach(x => {
        termsAdded.push({ isSelected: false, termName: x.name, termId: x.id });
      });

      groupAdded.terms = termsAdded;

      if (termGroupSelected.name === "People") {
        var _groupPeople = _groupsAdded.filter(x => x.title === null)[0];
        if (_groupPeople) {
          let indexPeople = _groupsAdded.indexOf(_groupPeople);
          if (indexPeople > -1) {
            _groupsAdded.splice(indexPeople, 1);
          }
        }
      }

      var _groups: any[] = this.state.termGroupOptions;

      const index = this.state.termGroupOptions.findIndex(x => x.key == option);
      if (index > -1) {
        _groups.splice(index, 1);
      }

      _groups = _groups.sort((x, y) => {
        if (x.text > y.text)
          return 1;

        if (x.text < y.text)
          return -1;

        return 0;
      });

      _groups.forEach(element => {
        if (element.key !== " ")
          element.selected = false;
        else
          element.selected = true;
      });

      _groupsAdded.push(groupAdded);

      _groupsAdded = _groupsAdded.sort((x, y) => {
        if (x.title > y.title)
          return 1;

        if (x.title < y.title)
          return -1;

        return 0;
      });

      this.setState({ termGroupOptions: _groups, groupsAdded: _groupsAdded, selectedTermGroup: " " });
    }
  }

  public syncTermsFromTermStore = () => {
    this.setState({ isLoading: true });

    this.state.groupsAdded.forEach(x => {
      x.terms.forEach(t => {
        if (t.isSelected) {
          this.state.termSetsSelected.push({ id: t.termId, name: t.termName });
        }
      });
    });

    if (this.state.termSetsSelected.length === 0) {
      this.setState({
        // isCalloutVisible: true,
        isLoading: false
      });
    }
    else {

      TargetingService.syncTerms(this.props.environment, this.state.termSetsSelected, this.props.tenant, this.props.token).then(() => {
        this.setState({
          isLoading: false,
          termSetsSelected: [],
          groupsAdded: [],

        }, () => {
          this.props.close(true);
        });

        // this.props.onDismiss(true, response);
      });
    }
  }
}